import React, { useContext } from "react"
import { Link } from "gatsby"
import { Snippet, Highlight } from "react-instantsearch"
import { ChildContext } from "../Layout"
import { useLocation } from "@reach/router"

function formatDate(dateStr) {
  if (!dateStr) return ""
  const d = new Date(dateStr)
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
}

function Hit({ hit }) {
  const { setShowSearchBox } = useContext(ChildContext)
  const { pathname } = useLocation()
  const isSlugInPathname = pathname.includes(hit.slug)

  // Filter out internal Ghost tags (starting with #)
  const publicTags = (hit.tags || []).filter(t => t.name && !t.name.startsWith("#"))

  return (
    <article>
      <Link to={`/blog/${hit.slug}/`} onClick={() => setShowSearchBox(false)}>
        <div className="px-5 py-4">
          <div className="flex items-center gap-2 mb-1.5">
            {hit.published_at && (
              <span className="text-xs text-gray-500">{formatDate(hit.published_at)}</span>
            )}
            {publicTags.length > 0 && (
              <div className="flex gap-1.5">
                {publicTags.slice(0, 2).map(tag => (
                  <span
                    key={tag.name}
                    className="text-xs px-1.5 py-0.5 rounded bg-gray-700 text-gray-400"
                  >
                    {tag.name}
                  </span>
                ))}
              </div>
            )}
          </div>
          <div
            className={`text-base font-semibold mb-1 text-gray-100${
              isSlugInPathname ? " !text-fBlue-800" : ""
            }`}
          >
            <Highlight attribute="title" hit={hit} />
          </div>
          <div className="text-sm text-gray-400 mb-2 line-clamp-2">
            <Snippet hit={hit} attribute="excerpt" />
          </div>
          <div className="text-sm text-gray-500 line-clamp-2">
            <Snippet hit={hit} attribute="plaintext" />
          </div>
        </div>
      </Link>
    </article>
  )
}

export default Hit
